import React from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  ExamInfoContainer,
  ExamTitle,
  DescriptionWrapper,
  Divisor,
  AllowContactButton,
  AllowedContactButton,
} from './styles';
import { Icon } from '~/shared/components';
import { Theme } from '~/styles';

const PrescriptionItem = ({
  title,
  description,
  contactAllowed,
  blockedContent = true,
  scheduleExam,
  icon = 'other_exam',
  allowSchedule = false,
  ...rest
}) => {
  return (
    <ItemContainer {...rest}>
      {!blockedContent && (contactAllowed === 1 || contactAllowed === true) && (
        <AllowedContactButton>Agendamento solicitado</AllowedContactButton>
      )}
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Icon name={icon} color="yellow1" size={Theme.iconSizes.medium} />
        <ExamInfoContainer>
          <div>
            <ExamTitle>
              <div data-testid="title">{title}</div>
            </ExamTitle>
            {!!description && <Divisor />}
          </div>
          {!!description && (
            <DescriptionWrapper data-testid="description">
              {description}
            </DescriptionWrapper>
          )}
          {!blockedContent && !contactAllowed && allowSchedule && (
            <AllowContactButton
              data-testid="blockedContent"
              onClick={scheduleExam}
            >
              Agendar exame
            </AllowContactButton>
          )}
        </ExamInfoContainer>
      </div>
    </ItemContainer>
  );
};

PrescriptionItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  contactAllowed: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  blockedContent: PropTypes.bool.isRequired,
  scheduleExam: PropTypes.func.isRequired,
  icon: PropTypes.string,
  allowSchedule: PropTypes.bool.isRequired,
};

PrescriptionItem.defaultProps = {
  description: null,
  icon: '',
  contactAllowed: null,
};

export default PrescriptionItem;
